import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-736c06ca"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "tree-node"
};
const _hoisted_2 = {
  key: 0,
  class: "level"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = ["onClick"];

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "edit-icon"
}, null, -1));

const _hoisted_7 = [_hoisted_6];
const _hoisted_8 = {
  class: "edit-btn"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "章节结构", -1));

const _hoisted_10 = {
  class: "column-list"
};
const _hoisted_11 = ["onClick"];

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "添加同级", -1));

const _hoisted_13 = [_hoisted_12];
const _hoisted_14 = ["onClick"];

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "添加子级", -1));

const _hoisted_16 = [_hoisted_15];
const _hoisted_17 = ["onClick"];

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-shangyi"
}, null, -1));

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "上移", -1));

const _hoisted_20 = [_hoisted_18, _hoisted_19];
const _hoisted_21 = ["onClick"];

const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-xiayi"
}, null, -1));

const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "下移", -1));

const _hoisted_24 = [_hoisted_22, _hoisted_23];
const _hoisted_25 = ["onClick"];

const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-shanchu1"
}, null, -1));

const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "删除", -1));

const _hoisted_28 = [_hoisted_26, _hoisted_27];
const _hoisted_29 = {
  class: "operation"
};

const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-baocun"
}, null, -1));

const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "保存", -1));

const _hoisted_32 = [_hoisted_30, _hoisted_31];

const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-quxiao"
}, null, -1));

const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "取消", -1));

const _hoisted_35 = [_hoisted_33, _hoisted_34];

const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "delete-tip"
}, "删除该章节后部分内容将没有所属章节", -1));

const _hoisted_37 = {
  class: "delete-btn"
};

const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-shanchu1"
}, null, -1));

const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "删除", -1));

const _hoisted_40 = [_hoisted_38, _hoisted_39];

const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-quxiao"
}, null, -1));

const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "取消", -1));

const _hoisted_43 = [_hoisted_41, _hoisted_42];
const _hoisted_44 = {
  class: "dialog-footer"
};

const _hoisted_45 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_46 = /*#__PURE__*/_createTextVNode("确定");

export default {
  props: {
    show: Boolean,
    courseId: String,
    // 选中的
    selected: String
  },
  emits: ['update:show', 'handleSeletedChapter'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const vFocus = {
      mounted(el) {
        el.children[0].focus();
      }

    };
    const $http = inject('$http');
    const chapterTree = ref();
    const treeProps = {
      value: 'id',
      label: 'name',
      children: 'children'
    };
    const chapterList = ref([]); // 获取章节树

    const getChapterList = async () => {
      const chapter = await $http.getTeachingCourseChapterTree({
        id: props.courseId
      });
      chapterList.value = chapter || [];
    };

    const handleClose = () => {
      emit('update:show', false);
    };

    const curItem = reactive({
      id: '',
      name: ''
    }); // 编辑删除操作

    const handleType = ref('');

    const handleChapter = (data, type) => {
      curItem.id = data.id;
      curItem.name = data.name;
      handleType.value = type;
    }; // 保存


    const handleSaveItem = async () => {
      await $http.updateTeachingCourseChapter(curItem);
      ElMessage.success('保存成功');
      handleCancelItem();
      getChapterList();
    }; // 删除


    const handleDeleteItem = async () => {
      await $http.deleteTeachingCourseChapter({
        ids: curItem.id
      });
      ElMessage.success('删除成功');
      handleCancelItem();
      getChapterList();
    }; // 取消


    const handleCancelItem = () => {
      curItem.id = '';
      curItem.name = '';
      handleType.value = '';
    }; // 添加章节


    const handleAddChapter = async pid => {
      let params = {
        names: '未命名章节',
        course_id: props.courseId,
        parent_outline_id: pid
      };
      await $http.addTeachingCourseChapter(params);
      ElMessage.success('添加成功');
      getChapterList();
    }; // 移动


    const handleSortChapter = async (data, move) => {
      let params = {
        parent_outline_id: data.pid,
        outline_id: data.id,
        sort: move ? +data.sort + 1 : +data.sort - 1
      };
      await $http.sortTeachingCourseChapter(params);
      ElMessage.success('移动成功');
      getChapterList();
    }; // 保存


    const handleConfirm = () => {
      const selected = chapterTree.value.getCurrentNode();

      if (!selected || selected.id == 0) {
        ElMessage.warning('当前未选择任何章节');
        return;
      }

      console.log('selected', selected);
      emit('handleSeletedChapter', selected);
      handleClose();
    };

    watch(() => props.courseId, value => {
      value && getChapterList();
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_CirclePlus = _resolveComponent("CirclePlus");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_popover = _resolveComponent("el-popover");

      const _component_ElInput = _resolveComponent("ElInput");

      const _component_ElTree = _resolveComponent("ElTree");

      const _component_el_scrollbar = _resolveComponent("el-scrollbar");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        modelValue: __props.show,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _isRef(show) ? show.value = $event : null),
        width: "600px",
        title: "选择章节",
        "before-close": handleClose,
        "destroy-on-close": "",
        "close-on-click-modal": false,
        "append-to-body": true
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_44, [_createVNode(_component_el_button, {
          size: "large",
          onClick: handleClose
        }, {
          default: _withCtx(() => [_hoisted_45]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          size: "large",
          onClick: _cache[8] || (_cache[8] = $event => handleConfirm())
        }, {
          default: _withCtx(() => [_hoisted_46]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
          class: "tree-box"
        }, {
          default: _withCtx(() => [_createVNode(_component_ElTree, {
            ref_key: "chapterTree",
            ref: chapterTree,
            data: chapterList.value,
            "node-key": "id",
            "default-expand-all": "",
            draggable: false,
            "expand-on-click-node": false,
            "current-node-key": __props.selected,
            props: {
              children: 'childs',
              label: 'name'
            }
          }, {
            default: _withCtx(({
              node,
              data
            }) => [_createElementVNode("div", _hoisted_1, [data.id != _unref(curItem).id ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(node.label), 1), _createElementVNode("div", {
              class: "edit-btn",
              onClick: _withModifiers($event => handleChapter(data, 'edit'), ["stop"])
            }, _hoisted_7, 8, _hoisted_5)]), _createElementVNode("div", {
              class: "right",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
            }, [_createVNode(_component_el_popover, {
              width: "auto",
              trigger: "hover",
              teleported: false,
              offset: -1
            }, {
              reference: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_icon, {
                class: "add-icon"
              }, {
                default: _withCtx(() => [_createVNode(_component_CirclePlus)]),
                _: 1
              }), _hoisted_9])]),
              default: _withCtx(() => [_createElementVNode("ul", _hoisted_10, [_createElementVNode("li", {
                class: "column-item",
                onClick: $event => handleAddChapter(data.pid)
              }, _hoisted_13, 8, _hoisted_11), node.level < 3 ? (_openBlock(), _createElementBlock("li", {
                key: 0,
                class: "column-item",
                onClick: $event => handleAddChapter(data.id)
              }, _hoisted_16, 8, _hoisted_14)) : _createCommentVNode("", true)])]),
              _: 2
            }, 1024), _createElementVNode("div", {
              class: _normalizeClass(["edit-btn", !node.previousSibling ? 'disabled' : '']),
              onClick: $event => handleSortChapter(data, 0)
            }, _hoisted_20, 10, _hoisted_17), _createElementVNode("div", {
              class: _normalizeClass(["edit-btn", !node.nextSibling ? 'disabled' : '']),
              onClick: $event => handleSortChapter(data, 1)
            }, _hoisted_24, 10, _hoisted_21), _createElementVNode("div", {
              class: "edit-btn",
              onClick: $event => handleChapter(data, 'delete')
            }, _hoisted_28, 8, _hoisted_25)])])) : _createCommentVNode("", true), data.id == _unref(curItem).id && handleType.value == 'edit' ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
              class: "level input-warp"
            }, [_withDirectives(_createVNode(_component_ElInput, {
              modelValue: _unref(curItem).name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(curItem).name = $event)
            }, null, 8, ["modelValue"]), [[vFocus]]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", {
              class: "edit-btn",
              onClick: _cache[2] || (_cache[2] = $event => handleSaveItem())
            }, _hoisted_32), _createElementVNode("div", {
              class: "edit-btn",
              onClick: _cache[3] || (_cache[3] = $event => handleCancelItem())
            }, _hoisted_35)])])) : _createCommentVNode("", true), data.id == _unref(curItem).id && handleType.value == 'delete' ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "level delete-box",
              onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
            }, [_hoisted_36, _createElementVNode("div", _hoisted_37, [_createElementVNode("div", {
              class: "edit-btn",
              onClick: _cache[5] || (_cache[5] = $event => handleDeleteItem())
            }, _hoisted_40), _createElementVNode("div", {
              class: "edit-btn",
              onClick: _cache[6] || (_cache[6] = $event => handleCancelItem())
            }, _hoisted_43)])])) : _createCommentVNode("", true)])]),
            _: 1
          }, 8, ["data", "current-node-key"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};